export default {
  date: 'Date',
  week: 'Week',
  settings: 'Calendar settings:',
  createCalendar: 'Create Calendar',
  createEvent: 'Create event',
  selectCalendar: 'Select calendar',
  publicCalendar: 'Public calendar',
  calendarDesc: 'For the public calendar, it is necessary to enter the ordering hours',
  selectColor: 'Select a calendar color',
  assignedService: 'Assigned service',
  type: {
    month: 'Month calendar',
    week: 'Week calendar',
    day: 'Day calendar'
  },
  bookingHours: {
    open: 'Opening at',
    close: 'Closing at',
    closed: 'Closed'
  },
  event: {
    add: 'Add event',
    createdBy: 'Created by',
    description: 'Description',
    durationInMinutes: 'Duration in minutes',
    name: 'Name',
    products: 'Products',
    searchAnimal: 'Find the animal and assign it to the event',
    startDate: 'Starting date',
    startTime: 'Start time',
    warning: 'Note the time of your event overlaps with the time of another event:'
  },
  status: {
    PROPOSED: 'Proposed',
    CONFIRMED: 'Confirmed',
    CANCELED: 'Canceled',
    DELETED: 'Deleted'
  },
  types: {
    REMINDER: 'Reminder',
    APPOINTMENT: 'Appointment'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/routes/calendar.js